import React, {useEffect, useState} from "react";
import FunctionsData from "../../Functions/FunctionsData";
import { Backdrop, CircularProgress, FormControlLabel, Switch } from "@mui/material";

/*
    ShowTable
    @param {object} data
 */
const ShowTable = ({data}) => {

    return (
        <div style={{marginTop:20}}>
            {data.map((row,idx) => (
                <div className={"vet-summary-box"} key={idx}>
                    <h1 style={{textDecoration:'underline', marginBottom:20}}>Schedule number: {row.id}</h1>
                    <h4>Vouchers: {row.all.length}</h4>
                    <h4>Total amount: ${row.total}</h4>
                    <h4>Created at: {new Date(row.created_at.slice(0,10)).toLocaleDateString('en-NZ')}</h4>
                    <small>
                    {row.all.map((r) => {
                        return (
                            <span>{"#"+r.Serial_Number} (${r.Nominal_Value}), </span>
                        )
                    })}
                    </small>
                </div>
            ))}
        </div>
    )
}

/*
    VetsInvoicing
    @param {number} vet_id
 */
export default function VetsInvoicing({vet_id}) {

    const [loading,setLoading] = useState(true);
    const [data,setData] = useState([]);

    useEffect(() => {
        FunctionsData.fetchDataGet(
            FunctionsData.getApiUrl('/api/vet/invoiced/')+ vet_id,
            setData,
            loading,
            setLoading
        )
    },[vet_id])

    //if(data.length === 0) return (<h3>Loading...</h3>);
    if(data.length === 0 && loading === true) return (<Backdrop open style={{ zIndex: 1000 }}>
                <CircularProgress color="inherit" />
            </Backdrop>);
    return (
        <div>
            <ShowTable data={data} />
        </div>
    )
}
